<label class="flex gap-4 justify-start">
    <button 
        type="button" 
        id="tvd-rounding-toggle-switch" 
        class="flex w-14 h-8 p-1 rounded-full overflow-hidden outline-none transition-colors focus:ring focus:ring-offset-0" 
        [ngClass] = "isChecked ? 'bg-blue' : 'bg-slate-400'"
        (click)="onToggleChange()">
        <span class="w-6 h-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out" [ngClass]="isChecked ? 'translate-x-full' : 'translate-x-0'"></span>
    </button>
    <span class="flex items-center text-base">{{label}}</span>
</label>  